import styled from 'styled-components';
import { TriggerTextMixin } from '../../mixins/components/TriggerTextMixin';
/**
 * Inline trigger style used for [`Tooltip`](#/Dialog%20components?id=tooltip) and
 * [`Popover`](#/Dialog%20components?id=popover) components in a body of text.
 *
 * See also [`TriggerButton`](#/Dialog%20components?id=triggerbutton)
 *
 * @since 7.0.0
 */

var TriggerText = /*#__PURE__*/styled.button.withConfig({
  displayName: "TriggerText",
  componentId: "c11n-8-64-0__sc-139r5uq-0"
})(["", ""], TriggerTextMixin);
TriggerText.defaultProps = {
  // Prevents submits when included in a form tag
  type: 'button'
};
/** @component */

export default TriggerText;
export var StyledTriggerText = TriggerText;